import Vue from 'vue'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { arraysEqual } from '@/tools/functions'
import { clone } from 'ramda'

export default {
    name: 'TreeSelectorComponent',
    /**
     * PROPS
     *
     * normalizer: función para adaptar el componente a una estructura de datos diferente.
     * data: arreglo con los datos que pueden ser seleccionados.
     * selectedValues: arreglo con ids de elementos seleccionados (para inicializar la selección).
     * singleSelect: booleano para indicar si el componente debe ser de selección simple o múltiple.
     */
    props: {
        selectedValues: {
            required: false,
            default: () => { return [] }
        },
        data: {
            type: Array,
            required: true
        },
        singleSelect: {
            type: Boolean,
            required: false,
            default: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        normalizer: {
            type: Function,
            required: false,
            default: (node) => {
                return {
                    id: node.id,
                    label: node.name,
                    children: node.children
                }
            }
        },
        disableBranch: {
            type: Boolean,
            required: false,
            default: false
        },
        alwaysOpen: {
            type: Boolean,
            required: false,
            default: true
        },
        openDirection: {
            type: String,
            required: false,
            default: 'auto'
        },
        maxHeight: {
            type: Number,
            required: false,
            default: 300
        },
        sortValue: {
            type: String,
            required: false,
            default: 'ascendent'
        },
        selectAllDefault: {
            type: Boolean,
            required: false,
            default: false
        }

    },
    components: {
        Treeselect
    },
    data () {
        return {
            search: '',
            selectAll: false,
            selected: []
        }
    },
    computed: {
    },
    mounted () {
        this.sortType = this.sortValue
        this.selectAll = this.selectAllDefault
    },
    methods: {
        /**
         * Ordenar la lista
         */
        sort () {
            this.sortType = this.sortType === 'descendent' ? 'descendent': 'ascendent'
            this.sortFunction(this.data, this.sortType)
        },

        changeSort(){
            this.sortType = this.sortType === 'descendent' ? 'ascendent': 'descendent'
            this.sortFunction(this.data, this.sortType)
        },
        /**
         * Función auxiliar usada por la función anterior
         * @param {*} list
         * @param {*} sortType
         */
        sortFunction (list, sortType) {
            const that = this
            if (sortType === 'descendent') {
                list.sort(function sort (a, b) {
                    const nameA = that.normalizer(a).label.toLowerCase()
                    const nameB = that.normalizer(b).label.toLowerCase()
                    if (nameA < nameB) {
                        return -1
                    } else if (nameA > nameB) {
                        return 1
                    } else {
                        return 0
                    }
                })
            } else {
                list.sort(function sort (a, b) {
                    const nameA = that.normalizer(a).label.toLowerCase()
                    const nameB = that.normalizer(b).label.toLowerCase()
                    if (nameA > nameB) {
                        return -1
                    } else if (nameA < nameB) {
                        return 1
                    } else {
                        return 0
                    }
                })
            }
            list.forEach(item => {
                if (item.children && item.children.length > 0) {
                    this.sortFunction(item.children, sortType)
                }
            })
        },
        /**
         * Cuando cambia el valor del checkbox para seleccionar todos, se ejecuta esta función
         */
        selectAllChanged () {
            if (!this.singleSelect) {
                if (this.selectAll) {
                    const firstLevelIds = this.data.map(item => this.normalizer(item).id)
                    this.selected = []
                    this.selected.cleanAndUpdate(firstLevelIds)
                } else {
                    this.selected = []
                }
            }
        },
        /**
         * Ordenar los valores seleccionados
         */
        sortSelections () {
            const selections = this.selected || []
            this.selected = selections.sort()
        },
        /**
         * Para activar el checkbox "Seleccionar todos" si se inicializan 
         */
        checkSelectAll () {
            const that = this
            Vue.nextTick(function () {
                if (!that.singleSelect) {
                    const firstLevelIds = that.data.map(item => that.normalizer(item).id)
                    firstLevelIds.sort()
                    that.sortSelections()
                    if (firstLevelIds.length > 0 || that.selected.length > 0) {
                        that.selectAll = arraysEqual(firstLevelIds, that.selected)
                    } else {
                        that.selectAll = false
                    }
                }
            })
        },
        /**
         * Emite un evento al padre con los nuevos valores seleccionados
         */
        input() {
            this.$emit('input', this.selected)
        }
    },
    watch: {
        selectedValues: {
            deep: true,
            immediate: true,
            handler(newValues) {
                this.selected = clone(newValues)
            }
        },
        selectAllDefault: function(newValue, oldValue){
            if(newValue !== oldValue) {
                this.checkSelectAll()
            }
        }
    }
}
